import { nsUser } from '@/app/i18n/namespaces';

const USER_STATUS = {
    ACTIVE: { name: 'ACTIVE', entity: 'status.ACTIVE', namespace: nsUser, variant: 'green' },
    INACTIVE: { name: 'INACTIVE', entity: 'status.INACTIVE', namespace: nsUser, variant: 'red' }
};

export default USER_STATUS;